import React, { PureComponent } from 'react'
import HeartrateZoner           from '../utils/heartrate_zoner'
import CategoryMarker           from './CategoryMarker'
import { titleize }             from 'inflected'
import ComponentHasTranslations from '../../../utils/component_has_translations'

class ActivityIndicator extends PureComponent {
  zoneHeightLg   = 60
  zoneHeightSm   = 55
  heartrateZoner = new HeartrateZoner

  constructor(props) {
    super(props);
    this.state = { 
      age: 30,
    }
  }

  componentDidMount () {
  }
  
  setAge = (e) => {
    this.setState(
      {age: parseInt(e.target.value) },
    )
  }

  zoneClass = (zone) => (
    (this.props.bpm == null || this.heartrateZoner.zoneNum() == zone) ? 'active' : 'inactive'
  )
  
  zoneHeight = () => {
    return this.props.breakpoint == 'sm' ? this.zoneHeightSm : this.zoneHeightLg 
  }

  zoneStyles = (zone) => (
    {
      backgroundColor: this.heartrateZoner.zoneColor(zone),
      height: `${this.zoneHeight() - 1}px` //-1 for border
    }
  )
  
  zone = (zone) => {
    const zone_label = this.heartrateZoner.zoneInfo('label', zone)
    const zone_perc = this.heartrateZoner.zoneInfo('perc', zone)

    return (
      <div key={zone} className={`category-cell ${this.zoneClass(zone)}`} id={`zone${zone}`} style={this.zoneStyles(zone)}>
        <div className='zone-num-cont'>
          <div className='zone-word'>{this.tr('zone')}</div>
          <div className='zone-num'>{zone}</div>
        </div>
        <div className='zone-img-cont'>
          <img src={`/images/zone_icons/${zone}.png` }/>
        </div>
        <div className='zone-desc-cont'>
          <div className='zone-desc'> {titleize(this.tr(zone_label))} </div>
          <div className='zone-desc-sub'> {zone_perc} </div>
          {/*
            of HR<sub>max</sub>
          */}
        </div>
      </div>
    )
  }

  markerPosition = () => {
    let pos = 0
    const h =  this.zoneHeight()
    const textSize = 20
    const perc = this.heartrateZoner.percent()

    if(perc < 50) {
      pos = (perc/50) * h
    } else if (perc <= 100) {
      pos = (perc - 50)/(10/h) + h
    } else {
      pos = 6 * h
    }
    return pos
  }

  details = () => (
    <table id='info-table' className='table table-borderless table-sm'>
      <tbody>
        <tr>
          <td>{this.tr('age')}</td>
          <td>
            <input 
              className='form-control form-control-sm'
              onChange={this.setAge} 
              placeholder='age' 
              value={this.state.age}
              type="number" 
              min="0" 
              step="1"
            />
          </td>
        </tr>
        { this.props.count > 0 &&
          <>
            <tr>
              <td> HR<sub>max</sub></td>
              <td> 
                {this.heartrateZoner.hrmax()}
              </td>
            </tr>
            <tr>
              <td> 
              % of HR<sub>max</sub> 
             </td>
              <td> 
                {this.heartrateZoner.percent()}%
              </td>
            </tr>
            <tr>
              <td> 
                {titleize(this.tr('zone'))}
                <br/>
                <br/>
              </td>
              <td> 
                {
                  titleize(
                    this.tr(
                      this.heartrateZoner.zoneInfo('label')
                    )
                  )
                }
              </td>
            </tr>
          </>
        }
      </tbody>
    </table>
  )
  
  render = () => {
    this.heartrateZoner.setData({
      bpm: this.props.bpm,
      age: this.state.age
    })

    this.props.setRateIndicatorColor(this.heartrateZoner.zoneColor())

    return (
      <>
        <div className='activity-indicator categories-with-marker'>
          { [5,4,3,2,1,0].map( zone => this.zone(zone)) }
          <CategoryMarker position={this.markerPosition()} />
        </div>
      
        { this.details() }
      </>
    )
  }
}

Object.assign(ActivityIndicator.prototype, ComponentHasTranslations)
export default ActivityIndicator
